/**
 * Optional phone validation: empty is valid; otherwise digits (and leading +) only,
 * length 8–20 after normalization — supports Australian national numbers (e.g. 04xx…)
 * and international (+61…) formats.
 */
export function isValidOptionalPhone(phone) {
  if (phone == null) return true;
  const trimmed = String(phone).trim();
  if (trimmed === '') return true;

  const cleaned = trimmed.replace(/[\s\-()]/g, '');
  if (!cleaned) return true;

  if (cleaned.startsWith('+')) {
    const rest = cleaned.slice(1);
    return /^\d{8,20}$/.test(rest);
  }
  return /^\d{8,20}$/.test(cleaned);
}
